import React from "react";

function AboutUs() {
  return (
    <>
      <div style={{ padding: "2rem", lineHeight: "1.8", fontSize: "1.1rem", color: "#fff", background: "linear-gradient(135deg, #000, #8b0000)" }}>
        <h2 style={{ color: "#ffcc00", textAlign: "center" }}>About Flytoez Dance Company</h2>

        <p>
          <b>FLYTOEZ Dance Company</b> is based in Ipswich, Colchester, Chelmsford United Kingdom.
        </p>

        <p>
          We proudly teach over <b>100 enthusiastic students</b> across all branches, offering classes for both children and adults.
        </p>

        <p>
          Our mission is to help students <b>learn, perform, and build confidence</b> while enjoying every step of their dance journey.
        </p>

        <p>
          At Flytoez, we specialize in <b>Bollywood, Hip-Hop, Contemporary,</b> and <b>Western</b> dance styles — blending energy, creativity, and discipline.
          Through dance, our students enhance not only their <b>fitness</b> and <b>rhythm</b> but also develop vital life skills such as
          <b> focus, teamwork, decision-making,</b> and <b>memory</b>.
        </p>

        <p>
          Flytoez is more than a dance school — it’s a <b>community</b> that celebrates <b>expression, culture,</b> and <b>joy through movement.</b>
        </p>

        <h3 style={{ marginTop: "2rem", color: "#ffcc00" }}>Meet Our Founder — Nessa</h3>

        <p>
          <b>Nessa</b>, the founder of Flytoez Dance Company, is a passionate dancer and choreographer dedicated to bringing artistic vision to life.
          Originally from South India, Nessa professionally trained with the <b>Flyerz Dance Company</b> in 2008 and later founded a successful
          corporate dance company called <b>Tapping Toez</b>.
        </p>

        <p>
          He has also performed as a <b>backstage dancer</b> for several popular <b>South Indian TV shows</b>, showcasing his talent and experience in the industry.
        </p>

        <h3 style={{ marginTop: "2rem", color: "#ffcc00" }}>An Industry-Leading Dance Company</h3>

        <p>
          Today, Flytoez continues to grow as one of the most dynamic and inclusive dance companies in East Anglia — inspiring students of all ages
          to embrace creativity, confidence, and culture through dance.
        </p>
      </div>
    </>
  );
}

export default AboutUs;
